import React from 'react';
import {
  TextField,
  Box,
  MenuItem,
  InputAdornment,
  Autocomplete,
  Typography,
  Button,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const FormInputMUI = ({
  label,
  type = 'text',
  value,
  onChange,
  error,
  minRows,
  maxRows,
  required = false,
  multiline = false,
  accept,
  multiple = false,
  select = false,
  options = [],
  name,
  containerClass,
  icon,
}) => {
  if (type === 'file') {
    return (
      <Box sx={{ mb: 2 }} className={containerClass}>
        <input
          accept={accept}
          multiple={multiple}
          type="file"
          id={`file-input-${name || label}`}
          style={{ display: 'none' }}
          onChange={(e) => {
            if (multiple) {
              onChange([...e.target.files]);
            } else {
              onChange(e.target.files[0]);
            }
          }}
        />
        <label htmlFor={`file-input-${name || label}`}>
          <Button
            variant="outlined"
            component="span"
            startIcon={<UploadFileIcon />}
            fullWidth
            sx={{ fontWeight: 'bold' }}
          >
            {label}{required ? ' *' : ''}
          </Button>
        </label>
        {value && (
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            {multiple
              ? `${value.length} fichier(s) sélectionné(s)`
              : `Fichier: ${value.name}`}
          </Typography>
        )}
      </Box>
    );
  }

  if (type === 'chip-select') {
    return (
      <Box sx={{ mb: 2 }} className={containerClass}>
        <Autocomplete
          multiple
          options={options}
          getOptionLabel={(option) => option.label}
          value={value}
          onChange={(e, newValue) => onChange(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label={required ? `${label} *` : label}
              error={!!error}
              helperText={error}
            />
          )}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }} className={containerClass}>
      <TextField
        label={label}
        type={type}
        fullWidth
        multiline={multiline}
         minRows={minRows}
        maxRows={maxRows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        helperText={error}
        variant="outlined"
        select={select}
        required={required}
        InputLabelProps={{ required }}
        InputProps={{
          startAdornment: icon ? (
            <InputAdornment position="start">
              <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                {React.cloneElement(icon, { fontSize: 'small' })}
              </Box>
            </InputAdornment>
          ) : null,
        }}
      >
        {select &&
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  );
};

export default FormInputMUI;
